import { render, staticRenderFns } from "./IconWithBackground.vue?vue&type=template&id=44a9f330&scoped=true&lang=true&"
import script from "./IconWithBackground.vue?vue&type=script&lang=js&"
export * from "./IconWithBackground.vue?vue&type=script&lang=js&"
import style0 from "./IconWithBackground.vue?vue&type=style&index=0&id=44a9f330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a9f330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
